@use './nav-list-item.vars' as *;
@use '../../../scss/global/color';
@use '../../../scss/global/typography';
@use '../../../scss/global/border';
@use './nav-list-item.mixins' as mixins;

.fds-nav-list-item {
  display: flex;
  flex: 1;
  background-color: var(--background-color-default);
  border-color: var(--border-color-default) var(--fds-color-common-transparent100, color.$default-transparent);
  border-style: solid;
  border-width: 1px;

  &--first:not(&--bordered) {
    border-top: none;
  }

  &--last:not(&--bordered) {
    border-bottom: none;
  }

  &--hide-top-border:not(#{&}--disabled) {
    border-top: none;
  }

  &--bordered {
    border-color: var(--border-color-default);
  }

  &--bordered#{&}--first {
    border-top-left-radius: border.$radius-1;
    border-top-right-radius: border.$radius-1;
  }

  &--bordered#{&}--last {
    border-bottom-left-radius: border.$radius-1;
    border-bottom-right-radius: border.$radius-1;
  }

  &__link {
    display: grid;
    grid-template:
      'headerIcon header nav' auto
      'headerIconEmpty secondaryHeaderAndDescription nav' auto
      / auto 1fr auto;
    flex: 1;
    padding: 1rem 0.5rem 1rem 1rem;
    color: var(--text-color-default);
    outline: none;
    text-decoration: none;
  }

  &__link--headerIcon {
    column-gap: 0.5rem;
  }

  &__header-icon {
    grid-area: headerIcon;
    align-self: center;
  }

  &__header-container {
    grid-area: header;
  }

  &__header {
    margin: 0;
    @include typography.lead-style(700);
  }

  &__secondary-header-and-description {
    grid-area: secondaryHeaderAndDescription;
    display: flex;
    flex-direction: column;
  }

  &__secondary-header {
    margin-top: 0.25rem;
    @include typography.ui-text-small-style(400);
  }

  &__description {
    @include typography.body-style(400);
  }

  &__nav {
    grid-area: nav;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    color: var(--nav-text-color);

    @include typography.ui-text-style(400);
  }

  &__empty-header-icon {
    grid-area: headerIconEmpty;
  }
}

@include mixins.nav-list-item-hover;
@include mixins.nav-list-item-focus;
@include mixins.nav-list-item-active;
@include mixins.nav-list-item-disabled;
